import styled from 'styled-components';

export const CeuManagementStyled = styled.div``;

export const ModalImportWrapper = styled.div``;
